import React, { Component } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import Footer from './Footer'
import HeaderTop from './HeaderTop'
import SideNavTop from './SideNavTop'
import '../Accueil.css'

class Politique extends Component {
state = {
    redirect:false,
    search: ''
    }

handleCHange = event => {
    const { name, value } = event.target
    this.setState({ [name]: value })
}

setRedirect = () => {
    this.setState({
      redirect: true
    })
  }
  
  handleSubmitFacebbok = () => {
    if (this.state.redirect) {
        window.location.href = "https://www.facebook.com/clubCAPN/";
    }
  }

handleSubmit = event => {
    //on gere le form
    event.preventDefault()
    this.props.history.push(`/recherche/${this.state.search}`);
}

render () {  
    return (
    <>
        <Container fluid>
        <Row>
            <SideNavTop/>
            <Col lg={10} md={12} sm={12} xs={12} id="page-content-wrapper" className="nopadding">
              <HeaderTop
                handleSubmit={this.handleSubmit}
                handleCHange={this.handleCHange}
                handleSubmitFacebbok={this.handleSubmitFacebbok}
                setRedirect={this.setRedirect}
              />

                <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                    <Row>
                    <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                    <div className="histoire-content">
                        <h1><span>Politiques et règlements du C.A.P.N</span></h1>   
                        <h2>MODALITÉS D'INSCRIPTION:</h2>
                        <p className="pCenter">Les résidents de Montréal ont priorité lors des journées d'inscription.
                        Ils devront, sur demande, présenter une pièce d'identité et une preuve de résidence valide.<br/>
                        Pré-inscriptions: Tout enfant préinscrit n'étant pas client du C.A.P.N. et / ou préinscrit sous de fausses déclarations, sera automatiquement
                        désinscrit et ce, sans remboursement.<br/>

                        En tout temps: Tout enfant inscrit sous de fausses déclarations sera automatiquement désinscrit et ce, sans remboursement.<br/>

                        Inscription en ligne: En tout temps, il y a des frais de transactions chargés par le fournisseur du service "Amilia".<br/>

                        Une activité peut être annulée si le nombre de participants est insuffisant ou en cas de force majeure.<br/>

                        Les horaires des activités et les prix sont sujets à changement sans préavis.<br/>

                        En cas de chèque sans provision, la totalité de l'inscription ainsi que
                        les frais supplémentaires engendrés par ce chèque devront obligatoirement être remboursés en argent comptant,
                        dans les sept jours suivant l'appel de l'employé en charge du C.A.P.N.
                        Faute de quoi, le participant n'aura pas accès à l'activité auquel il est inscrit.<br/><br/>
                        </p>
                        <h2>MONTANT POUR LA CONDITION PHYSIQUE DES ENFANTS</h2>   
                        <p className="pCenter">Le reçu d'inscription sert pour le crédit d'impôt pour la condition physique des enfants au fédéral.<br/>
                        Les documents sur le crédit d'impôt pour la condition physique des enfants sont envoyés par courriel aux parents.
                        Les parents désirant avoir une copie papier devront débourser le somme de 5$.<br/>

                        Lien: <a className="link-history" href="https://www.cra-arc.gc.ca">Agence du revenu du Canada</a>
                        </p>
                        <h2>MODALITÉS DE REMBOURSEMENT</h2>   
                        <p className="pCenter">Les demandes de remboursement devront être reçues par la coordination avant le début des cours.
                        Passé ce délai, un remboursement partiel sera accordé selon l'évaluation de votre dossier. Les demandes devront être envoyées par écrit via la poste ou courriel.<br/>
                        Dans le cas d'une activité annulée par le C.A.P.N., un remboursement total est accordé.<br/>

                        Les frais de transaction chargés par Amilia lors des inscriptions en ligne ne sont pas remboursés.<br/>

                        Aucun remboursement ne sera accordé pour les achats de matériel et / ou vêtement fait au C.A.P.N. Il s'agit dans tous les cas d'une vente finale.<br/>

                        Afin de faire une demande de remboursement, vous devez remplir la résiliation de contrat placer ci-bas et nous la faire parvenir avant le
                        début de votre cours pour un remboursement complet du Coût de l'inscription avec notre organisme.<br/></p>
                        <Col lg={12} md={12} sm={12} xs={12} className="nopadding link-emploi">
                          <a href="/_Résiliation de contrat.docx" className="btn btn-primary btn-blue-light emploi" target="_blank" download>
                          TOUTES LES INFORMATIONS ICI
                          </a>
                        </Col>
                        
                                      
                    </div>

                    </Col>
                    </Row>
                </Col>


            <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                <Footer />
            </Col>
            </Col>
        </Row>
        </Container>
    </>
    )
}
}

export default Politique
